import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "@/plugins/vee-validate";
import "./assets/scss/global.scss";

Vue.config.productionTip = false;

import axiosPlugin from "./plugins/axios-plugin";

Vue.use(axiosPlugin);

import VuetifyDialog from "vuetify-dialog";
import "vuetify-dialog/dist/vuetify-dialog.css";
import ConfirmDialog from "./components/dialog/ConfirmDialog.vue";

Vue.use(VuetifyDialog, {
  context: {
    vuetify,
    store
  },
});
Vue.prototype.$dialog.component('Confirm', ConfirmDialog)

Vue.use(require("vue-moment"));

import * as filters from "./filters";

// Register all filters
Object.keys(filters).forEach((filterName) => {
  Vue.filter(filterName, filters[filterName]);
});

import DatetimePicker from 'vuetify-datetime-picker'
Vue.use(DatetimePicker)

import VueCurrencyFilter from "vue-currency-filter";

Vue.use(VueCurrencyFilter, [
  {
    name: "usd",
    symbol: "$",
    thousandsSeparator: ",",
    fractionCount: 2,
    fractionSeparator: ".",
    symbolPosition: "front",
    symbolSpacing: true,
    avoidEmptyDecimals: undefined,
  },
  {
    name: "bs",
    symbol: "Bs.",
    thousandsSeparator: ",",
    fractionCount: 2,
    fractionSeparator: ".",
    symbolPosition: "front",
    symbolSpacing: true,
    avoidEmptyDecimals: undefined,
  },
]);

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
